import React from 'react';
import { useApi } from 'Service/axios';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { useState } from 'react';
import { Box } from '@mui/system';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const ActionButtonsTabela = ({ row, setOpenModalPdf, getEntradaById }) => {
    /////////////////////////////// INSTANCIAS /////////////////////////
    const api = useApi();
    /////////////////////////////// STATES /////////////////////////
    const [openDialog, setOpenDialog] = useState(false);
    /////////////////////////////// FUNÇÕES /////////////////////////
    const handleDeleteEntrada = async (entradaId) => {
        try {
            await api.deleteEntradaEstoque(entradaId);
            setOpenDialog(false);
            toast.success('Entrada deletada com sucesso');
        } catch (error) {
            toast.error('Erro ao deletar entrada');
        }
    };

    return (
        <Box>
            <Dialog open={openDialog}>
                <DialogTitle>Atenção</DialogTitle>
                <DialogContent>Tem certeza que deseja excluir essa entrada?</DialogContent>
                <DialogActions>
                    <Button color="error" onClick={() => setOpenDialog(false)}>
                        não
                    </Button>
                    <Button variant="contained" onClick={() => handleDeleteEntrada(row.id)}>
                        sim
                    </Button>
                </DialogActions>
            </Dialog>
            <Tooltip title="Vizualizar Entrada">
                <Link to={`/main/estoque/entrada/${row.id}`}>
                    <Button>
                        <EditIcon />
                    </Button>
                </Link>
            </Tooltip>
            <Tooltip title="Relatório">
                <Button
                    onClick={() => {
                        getEntradaById(row.id);
                    }}
                >
                    <ReceiptIcon />
                </Button>
            </Tooltip>
        </Box>
    );
};

export default ActionButtonsTabela;
